import {
  LitElement,
  html,
  TemplateResult,
} from 'lit';
import {customElement, state} from 'lit/decorators';
import {ILegendGroupInfo, ILegendInfo, ILegendLayerInfo, ILegendSymbol, MapLayerKMS} from '../../../shared/map/kelydra-map';
import { SilverBrowserMapLayerControl } from './sb-carto-layer-control';
import { mapLegendStyles } from './sb-carto-styles';
import { scrollbarStyles } from '../../../core/styles';

//https://stackoverflow.com/questions/5209545/css-overflow-yvisible-overflow-xscroll

/**
 * @customElement 'sb-map-layer-legend'
 */
@customElement('sb-map-layer-legend')
export class SilverBrowserMapLayerLegend extends LitElement {

  static styles = [
    mapLegendStyles,
    scrollbarStyles
  ];


  _layerControl:SilverBrowserMapLayerControl;


  @state()
  legendInfo:ILegendInfo;

  @state()
  _filter:string;

  haveFilter:boolean;


  layers:{[name:string]:ILegendLayerInfoView} = {};


  get filter():string {
    return this._filter;
  }

  set filter(value:string) {
    this._filter = value;
    this.updateFilter();
  }

  originalLayerVisibility:{[name:string]:boolean} = {};

  constructor() {
    super();
    console.log("SilverBrowserMapLayerLegend constructor")
  }



  viewAction(action:'visibility.hide' | 'visibility.show' | 'visibility.reset' | 'tree.close' | 'tree.open') {
    let groupVisitor:(parent:ILegendGroupInfoView, element:ILegendGroupInfoView) => void;
    let layerVisitor:(parent:ILegendGroupInfo, element:ILegendLayerInfoView) => void;
    switch (action) {
      case 'tree.close':
      case 'tree.open':
        let collapse = action === 'tree.close'; 
        groupVisitor = (parent, group) => {group._collapsed = collapse};
        layerVisitor = (group, layer) => {layer._collapsed = collapse};
        break;
      case 'visibility.hide':
      case 'visibility.show':
        let visibility = action === 'visibility.show'; 
        groupVisitor = (parent, group) => {};
        layerVisitor = (group, layer) => {layer.visible = visibility};
        break;
      case 'visibility.reset':
        groupVisitor = (parent, group) => {};
        layerVisitor = (group, layer) => {layer.visible = this.originalLayerVisibility[layer.name]};
        break;
      }

      this.visitTree(groupVisitor, layerVisitor);
      this.requestUpdate();
  }

  protected visitTree(groupVisitor:(parent:ILegendGroupInfoView, element:ILegendGroupInfoView) => void, layerVisitor:(parent:ILegendGroupInfo, element:ILegendLayerInfoView) => void) {
    let visitChildren = (group:ILegendGroupInfoView) => {
      (group.children || []).forEach(child => {
        groupVisitor(group, child);
        visitChildren(child);
      });

      (group.layersName || []).forEach(layerName => {
        layerVisitor(group, this.layers[layerName]);
      });

    }

    visitChildren(this.legendInfo.root);
  }

  updateLegend():void {
    //Invoca il servizio remoto per avere informazioni
    if (!this._layerControl) {
      return;
    }

    let mapLayer = this._layerControl.layer as MapLayerKMS;
    if (!mapLayer) {
      return;
    }


    if (!this.legendInfo) {
      fetch(mapLayer.url+"/map/legend/full",{credentials: "include"})
        .then((response: Response) => response.json())
        .then((legendInfo:ILegendInfo) => {
          this.legendInfo = legendInfo;
          this.legendInfo.layers.forEach(layer => {
            this.layers[layer.name] = layer;
            this.originalLayerVisibility[layer.name] = layer.visible;
          });
      
          this.updateLegendVisibility(false);
        }).catch(error => {
          console.error(error);
      });
    } else {
      this.updateLegendVisibility(true);
    }



  }

  updateLegendVisibility(update:boolean = false) {

    let mapLayer = this._layerControl.layer as MapLayerKMS;


    const visibleLookup = (mapLayer.queryStringVisibleLayers || '').split(",").reduce((lookup, layerName) => {lookup[layerName] = true; return lookup},<any>{})
    const hiddenLookup = (mapLayer.queryStringHiddenLayers || '').split(",").reduce((lookup, layerName) => {lookup[layerName] = true; return lookup},<any>{})

    this.legendInfo.layers.forEach(layer => {
      layer.visible = this.originalLayerVisibility[layer.name];

      if (visibleLookup[layer.name]) {
        layer.visible = true;
      }          

      if (hiddenLookup[layer.name]) {
        layer.visible = false;
      }          


    });

    this.visitTree((parent, group) => {group._parent = parent}, (group, layer) => {layer._parent = group});
    if (update) {
      this.requestUpdate();
    }
  }

  updateLayer() {
    let layer = this._layerControl.layer as MapLayerKMS;
    if (!layer) {
      return;
    }
    var visible = "";
    var hidden = "";
    for (let layerName in this.layers) {
      let layer = this.layers[layerName];
      if (layer.visible !== this.originalLayerVisibility[layerName]) {
        if (layer.visible) {
            visible += (visible ? "," : "") + layer.name;
        } else {
            hidden += (hidden ? "," : "") + layer.name +",";
        }
      }
    }
    layer.queryStringVisibleLayers = visible;
    layer.queryStringHiddenLayers = hidden;

    layer.map.updateLayers();
  }


  handleInfoClick(event:MouseEvent, item:ILegendLayerInfo) {
    this._layerControl.notifyLayerInfo(event, item);
  }


  handleCollapseClick(event:MouseEvent, item:ILegendLayerInfoView | ILegendGroupInfoView) {
    item._collapsed = !item._collapsed;
    this.requestUpdate();
  }

  doChangeLayerVisibility(e:InputEvent, legendLayer: ILegendLayerInfo) {
    let visibility = (e.target as HTMLInputElement).checked;
    legendLayer.visible = visibility;
    this.requestUpdate();
    this.updateLayer();
    this._layerControl.notifyVisibilityChange('layer', legendLayer.name, legendLayer.visible);
  }

  doChangeGroupVisibility(e:InputEvent, legendGroup: ILegendGroupInfo) {
    let visibility = (e.target as HTMLInputElement).checked;
    this.setGroupVisibility(legendGroup, visibility, true);
    this.requestUpdate();
    this.updateLayer();
  }


  getGroupVisibility(legendGroup: ILegendGroupInfoView):boolean {
    for (let i = 0; i < legendGroup.children?.length; i++) {
      if (this.getGroupVisibility(legendGroup.children[i])) {
        return true;
      }
    }
    for (let i = 0; i < legendGroup.layersName?.length; i++) {
      if (this.layers[legendGroup.layersName[i]].visible) {
        return true;
      }
    }

    return false;
  }

  setGroupVisibility(legendGroup: ILegendGroupInfo, visibility:boolean, fireEvent:boolean) {
    for (let i = 0; i < legendGroup.children?.length; i++) {
      this.setGroupVisibility(legendGroup.children[i], visibility, false);
    }
    for (let i = 0; i < legendGroup.layersName?.length; i++) {
      this.layers[legendGroup.layersName[i]].visible = visibility;
    }
    this._layerControl.notifyVisibilityChange('group', legendGroup.name, visibility);
  }



protected updateFilter() {
  console.log("filter for "+ this._filter);

  const filter =  (this._filter || "").toLowerCase();
  this.haveFilter = !!filter;

  this.visitTree((parent, group) => {group._hidden = this.haveFilter}, (group, layer) => {layer._hidden = this.haveFilter});

  if (this.haveFilter) {
    //Filtro i layer
    for (let layerName in this.layers) {
      let layer = this.layers[layerName];
      let hidden = true;
      if (layer.caption.toLowerCase().indexOf(filter) >= 0) {
        hidden = false;  
      } else {
        //TODO Verifico i simboli
        if (layer.symbols) {
          for (let symbol of layer.symbols) {
            if (((symbol.label + symbol.value) || '').toLowerCase().indexOf(filter) >= 0) {
               hidden = false;
               break; 
            }
          }
        }
      } 

      layer._hidden = hidden;  

      //Rendo visibili i layer filtrati ed i parent
      if (!layer._hidden) {
        let group = layer._parent;
        while (group) {
          group._hidden = false;
          group = group._parent;
        }
      }
    }
  }
}


render():TemplateResult {
  if (!this.legendInfo) {
    return;
  }

  return html`
    ${this.renderGroup(this.legendInfo.root)}
  `;
}

renderGroup(legendGroup:ILegendGroupInfoView, root:boolean = true):TemplateResult {
  if (legendGroup._hidden) {
    return null;
  }
  return html`
    <div class="legend-group">
      ${root ? null : this.renderGroupHeader(legendGroup)}
      ${!legendGroup._collapsed || this.haveFilter ? 
        html`
        ${this.renderGroupLayers(legendGroup)}
        <div class="legend-children">
          ${legendGroup.children.map((child) => {
              return this.renderGroup(child, false)
            }
          )}
        </div>
        ` : null
      
      }
    </div>
  `
}

renderGroupHeader(legendGroup:ILegendGroupInfoView):TemplateResult {
  return html`
    <div class="legend-header">
      <div class="legend-display"><input type="checkbox" .checked=${this.getGroupVisibility(legendGroup)} @input=${(e:InputEvent) => this.doChangeGroupVisibility(e, legendGroup)}></input></div>
      <div class="legend-caption"><div class="legend-label">${legendGroup.caption}</div></div>
      <div class="legend-buttons">
        <div class=${"legend-collapse " + (legendGroup._collapsed ? "open" : "close")}
             @click=${(event: MouseEvent) => this.handleCollapseClick(event, legendGroup)}></div>
      </div>
    </div>
  `
}

renderGroupLayers(legendGroup:ILegendGroupInfo):TemplateResult {
  return html`
    <div class="legend-layers">
      ${legendGroup.layersName.map((layerName) => {
          return this.renderLayer(this.layers[layerName])
        }
      )}
    </div>
  `
}

renderLayer(legendLayer:ILegendLayerInfoView) {
  if (legendLayer._hidden) {
    return null;
  }
  return html`
    <div class="legend-layer">
      ${this.renderHeader(legendLayer)}
      ${this.renderSymbols(legendLayer)}
    </div>
  `
}

renderHeader(legendLayer:ILegendLayerInfo) {
  return html`
    <div class="legend-header">
      <div class="legend-display"><input type="checkbox" .checked=${legendLayer.visible} @input=${(e:InputEvent) => this.doChangeLayerVisibility(e, legendLayer)}></input></div>
      <div class="legend-caption"><div class="legend-label">${legendLayer.caption}</div></div>
      <div class="legend-buttons">
        ${legendLayer.extraInfo ? html`
          <div class="legend-info"
              @click=${(event: MouseEvent) => this.handleInfoClick(event, legendLayer)}></div>
        `:null}
        <div class=${"legend-collapse " + ((legendLayer as any)._collapsed ? "open" : "close")}
             @click=${(event: MouseEvent) => this.handleCollapseClick(event, legendLayer)}></div>
      </div>
    </div>
  `
}

renderSymbols(legendLayer:ILegendLayerInfoView) {
  if (!(legendLayer._collapsed) || this.haveFilter) {
    return html`
    <div class="legend-symbols">
      ${legendLayer.symbols.map((symbol) => { 
        return html`
        <div class="legend-symbol">
          <div class="legend-symbol-image"><img src=${symbol.imageData}></img></div>
          <div class="legend-symbol-caption"><div class="legend-label">${symbol.label}</div></div>
        </div>
      `})}
    </div>
    `
  }
}




}


interface ILegendGroupInfoView extends ILegendGroupInfo {
  _collapsed?:boolean;
  _parent?:ILegendGroupInfo;
  _hidden?:boolean;
}

interface ILegendLayerInfoView extends ILegendLayerInfo {
  _collapsed?:boolean;
  _parent?:ILegendGroupInfoView;
  _hidden?:boolean;
}

interface ILegendSymbolView extends ILegendSymbol {
  _parent?:ILegendGroupInfoView;
  _hidden?:boolean;
} 